"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var EntityStateFlag_1 = require("../../core/model/EntityStateFlag");

var PriceListRow_1 = require("../model/PriceListRow");

var PriceListRowConverter_1 = require("./PriceListRowConverter");
/**
 * Implementation of {@link PriceListConverter}
 *
 * @author RV
 * @author VRu
 */


var PriceListRowConverterImpl =
/*#__PURE__*/
function (_PriceListRowConverte) {
  _inherits(PriceListRowConverterImpl, _PriceListRowConverte);

  function PriceListRowConverterImpl() {
    _classCallCheck(this, PriceListRowConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(PriceListRowConverterImpl).apply(this, arguments));
  }

  _createClass(PriceListRowConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new PriceListRow_1.PriceListRow(PriceListRow_1.PriceListRow.schema.id.valueOf(conversions.documentToClassId(source)), PriceListRow_1.PriceListRow.schema.externalId.valueOf(source.externalId), PriceListRow_1.PriceListRow.schema.priceListId.valueOf(conversions.toClassReferenceId(source.priceListId)), PriceListRow_1.PriceListRow.schema.priceListTypeId.valueOf(conversions.toClassReferenceId(source.priceListTypeId)), PriceListRow_1.PriceListRow.schema.priority.valueOfField(source), PriceListRow_1.PriceListRow.schema.groupOfSiteId.valueOf(conversions.toClassReferenceId(source.groupOfSiteId)), PriceListRow_1.PriceListRow.schema.productId.valueOf(conversions.toClassReferenceId(source.productId)), PriceListRow_1.PriceListRow.schema.amount.valueOf(conversions.toBigNumber(source.amount)), PriceListRow_1.PriceListRow.schema.vatId.valueOf(conversions.toClassReferenceId(source.vatId)), PriceListRow_1.PriceListRow.schema.dateFrom.valueOfField(source), PriceListRow_1.PriceListRow.schema.dateTo.valueOfField(source), PriceListRow_1.PriceListRow.schema.priceCodeId.valueOf(conversions.toClassReferenceId(source.priceCodeId)), PriceListRow_1.PriceListRow.schema.promotionId.valueOf(conversions.toClassReferenceId(source.promotionId)), conversions.asFlagSet(source.stateFlags, EntityStateFlag_1.EntityStateFlag), PriceListRow_1.PriceListRow.schema.processed.valueOfField(source));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, conversions.classToDocumentId(source));
      Object.assign(result, {
        externalId: source.externalId,
        priceListId: conversions.toDocumentReferenceId(source.priceListId),
        priceListTypeId: conversions.toDocumentReferenceId(source.priceListTypeId),
        priority: source.priority,
        groupOfSiteId: conversions.toDocumentReferenceId(source.groupOfSiteId),
        productId: conversions.toDocumentReferenceId(source.productId),
        amount: conversions.fromBigNumber(source.amount),
        vatId: conversions.toDocumentReferenceId(source.vatId),
        dateFrom: conversions.fromDate(source.dateFrom),
        dateTo: conversions.fromDate(source.dateTo),
        priceCodeId: conversions.toDocumentReferenceId(source.priceCodeId),
        promotionId: conversions.toDocumentReferenceId(source.promotionId),
        stateFlags: source.stateFlags.serialize(),
        processed: source.processed
      });
      return result;
    }
  }]);

  return PriceListRowConverterImpl;
}(PriceListRowConverter_1.PriceListRowConverter);

exports.PriceListRowConverterImpl = PriceListRowConverterImpl;